import React from "react";
import { Ptag } from "components/core";
import { GradeAttributeDetailWrapper } from "./styles";
import GradeAttributeCard from "./GradeAttributeCard";
import RenderList from "./AttributeRenders/RenderList";
import RenderDefault from "./AttributeRenders/RenderDefault";
import AttributeMaternity from "./AttributeRenders/AttributeMaternity";
import AttributeRoomRent from "./AttributeRenders/AttributeRoomRent";

function GradeAttributeDetail({ attribute }) {
  console.log("attribute", attribute);
  return (
    <GradeAttributeDetailWrapper>
      <header>
        <img src={attribute?.icon} alt="" />
        <div>
          <Ptag fontWeight="600" fontSize="18px" color="#4a4a4a">
            {attribute?.display_name}
          </Ptag>
          <Ptag
            fontWeight="400"
            fontSize="14px"
            marginTop="6px"
            color="#585858"
          >
            {attribute?.description}
          </Ptag>
        </div>
      </header>
      <section>
        {(() => {
          // Check if all values are null
          const hasNullValues = attribute?.data?.values && 
            Object.values(attribute.data.values).every(value => 
              value === null || value === undefined || value === ""
            );
          
          if (hasNullValues) {
            return (
              <Ptag fontSize="14px" color="#999">
                null
              </Ptag>
            );
          }
          
          if (attribute?.name === "Maternity Coverage") {
            return <AttributeMaternity data={attribute?.data} />;
          } else if (attribute?.name === "Room Rent Limit") {
            return <AttributeRoomRent data={attribute?.data} />;
          } else if (attribute?.data?.type === "LIST") {
            return <RenderList list={attribute?.data?.values} />;
          } else if (attribute?.data?.type === "DEFAULT") {
            return <RenderDefault data={attribute?.data?.values} />;
          } else {
            return null; // Optional: handle cases where no condition is met
          }
        })()}
      </section>
    </GradeAttributeDetailWrapper>
  );
}

export default GradeAttributeDetail;
